<div
  [ngSwitch]="cellType"
  class="table-cell"
  [ngClass]="'table-cell--' + verticalBreakpoint + ' truncate-' + cell.truncation || 'none'"
>
  <ftr-icon
    class="table-cell__icon"
    *ngIf="cell.icon as icon"
    [icon]="icon.name"
    [align]="icon.alignment || 'Sub'"
    [color]="icon.color || 'Grey'"
    [size]="icon.size || 'Regular'"
    [gapRight]="icon.gapRight"
    [gapLeft]="icon.gapLeft"
  ></ftr-icon>

  <span *ngSwitchCase="'text'" [title]="cell.data" class="table-cell__text">
    <span
      ftrTooltip
      [message]="asTextCell(cell).tooltip?.message ?? ''"
      [forceDisplayState]="
        validateForceDisplayState(asTextCell(cell).tooltip?.forceDisplayState, asTextCell(cell).tooltip?.message)
      "
      [alignment]="asTextCell(cell).tooltip?.alignment ?? tooltipAlignment.CENTER"
      [position]="asTextCell(cell).tooltip?.position ?? tooltipPosition.ABOVE"
      [showDash]="asTextCell(cell).tooltip?.showDash ?? false"
      [clickToStayOpen]="asTextCell(cell).tooltip?.clickToStayOpen ?? false"
      >{{ cell.data }}</span
    >
    <ftr-icon
      class="table-cell__text__copy"
      *ngIf="asTextCell(cell).canCopy"
      ftrTooltip
      [message]="'Copy ' + columnName + ' to clipboard'"
      [showDash]="false"
      [icon]="'Copy'"
      [color]="'Grey'"
      [align]="'TextBottom'"
      [gapLeft]="'Small'"
      (click)="copyToClipboard(cell.data, $event)"
    ></ftr-icon>
  </span>
  <span *ngSwitchCase="'badge'">
    <ftr-badge
      *ngIf="asBadgeCell(cell).data as badge"
      [icon]="badge.icon"
      [color]="badge.color"
      [text]="badge.label"
      [greyTextColor]="badge.greyTextColor"
    ></ftr-badge>
  </span>
  <span *ngSwitchCase="'link'" [title]="cell.data">
    <a [routerLink]="asLinkCell(cell).routerLink" [tabIndex]="0">{{ cell.data }}</a>
  </span>
  <span *ngSwitchCase="'date'" [title]="cell.data | ftrDate: { format: asDateCell(cell).titleFormat }">
    {{ cell.data | ftrDate: { format: asDateCell(cell).format } }}
  </span>
  <span *ngSwitchCase="'template'">
    <ng-container *ngTemplateOutlet="asTemplateCell(cell).template; context: { $implicit: cell.data }"></ng-container>
  </span>
  <span *ngSwitchCase="'action'">
    <ftr-table-cell-action
      *ngFor="let action of asActionCell(cell).actions; trackBy: trackActionBy"
      [tableAction]="action"
      [data]="cell.data"
    >
    </ftr-table-cell-action>
  </span>
</div>
